import "./styles.css";

import header2 from "../../assets/header2.png";
import header3 from "../../assets/mobile/header3.png";
import whats from "../../assets/whats.png";

import CTAForm from "../../components/CTAForm";

const Header = () => {
  return (
    <header id="header">
      <section className="header1">
        <article className="container">
          <h1 className="title">
            <span>SAV: </span>
            Sistema de Antecipação de Vulnerabilidade
          </h1>

          <p className="text">
            Revolucione suas inspeções de segurança com o SAV - a ferramenta de
            antecipação de vulnerabilidades que aproveita a tecnologia de IA de
            ponta para otimizar a conformidade e proteger sua força de trabalho.
          </p>

          <CTAForm />
        </article>
      </section>

      <section className="mobile">
        <article className="container">
          <h1 className="title">
            <span>SAV: </span>
            Sistema de Antecipação de Vulnerabilidade
          </h1>

          <p className="text">
            Revolucione suas inspeções de segurança com o SAV - a ferramenta de
            antecipação de vulnerabilidades que aproveita a tecnologia de IA de
            ponta para otimizar a conformidade e proteger sua força de trabalho.
          </p>

          <CTAForm />
        </article>
      </section>

      <section className="header2">
        <article className="container">
          <figure>
            <img src={header2} alt="Ícone de estrelas" />
          </figure>
          <p className="text">
            A ferramenta de inspeção que transformará a segurança do trabalho
            com IA
          </p>
        </article>
      </section>

      <section className="header3">
        <article className="container">
          <div className="left"></div>

          <div className="right">
            <h2 className="title">
              Imagine reduzir, em até 50%, o tempo de uma inspeção de segurança
              na obra e, ainda, aumentar a <span>prevenção de acidentes</span>
            </h2>

            <figure className="mobile">
              <img src={header3} alt="Ícone de Celular" />
            </figure>

            <p className="text">
              O SAV é essa ferramenta! É mais agilidade, mais precisão e mais
              proteção, na palma da sua mão.
            </p>

            <CTAForm />
          </div>
        </article>
      </section>

      <section id="wppFlutuante">
        <a
          href="http://wa.me/+5511999999999?text=Gostaria%20de%20saber%20mais"
          target="_blank"
          rel="noreferrer"
        >
          <figure>
            <img src={whats} alt="Ícone do Whatsapp" />
          </figure>
        </a>
      </section>
    </header>
  );
};

export default Header;
